"use client"

import { UtensilsCrossed } from "lucide-react"
import { component, Icon } from "../icon"

/**
 * `UtensilsCrossedIcon` is [Lucide](https://lucide.dev) SVG icon component.
 *
 * @see https://yamada-ui.com/docs/components/icon
 */
export const UtensilsCrossedIcon = component(Icon)({ as: UtensilsCrossed })
